<template>
    <div
        :style="{ width: autocompleteWidth }"
        :class="{ 'pt-email-auto-complete': true, 'error': isSomeoneEmailInvalid }"
    >
        <div
            ref="container"
            class="pt-email-auto-complete__container"
        >
            <!--content-->
            <div
                ref="wrapper"
                :class="{
                    'pt-email-auto-complete__users-input': true,
                    'pt-email-auto-complete__users-input--active': isFocus
                }"
                @click="onFocus"
            >
                <!--placeholder-->
                <div
                    v-show="!isFocus && isPlaceholderDisplay"
                    class="pt-email-auto-complete__users-input__placeholder"
                >
                    {{ placeholderContent }}
                </div>
                <!--输入区域-->
                <div class="pt-email-auto-complete__users-input__main">
                    <div class="pt-email-auto-complete__users-input__container">
                        <div
                            v-for="(user, index) in currentSelected"
                            :key="index"
                            :class="{
                                'pt-email-auto-complete__users-input__item': true,
                                'pt-email-auto-complete__users-input__item--error': !user.isValid || errorUserList.includes(user.userId)
                            }"
                            @click.stop
                        >
                            <span
                                v-if="user.isValid && !errorUserList.includes(user.userId)"
                                :style="{ 'background-color': getSuggestionColor(user.label.slice(0, 1)) }"
                                :class="{
                                    'pt-email-auto-complete__users-input__item-avator': true,
                                    'pt-email-auto-complete__users-input__item-avator--group': user.type === 'group'
                                }"
                            >
                                {{ user.label.slice(0, 1).toUpperCase() }}
                            </span>
                            <span class="pt-email-auto-complete__users-input__item-text">{{ user.label }}</span>
                            <PtIcon
                                class="pt-email-auto-complete__users-input__item-close"
                                icon="SolidCloseMedium"
                                @click.stop="onRemoveSelected(user)"
                            />
                        </div>
                        <input
                            ref="input"
                            v-model="currentInputing"
                            type="text"
                            class="pt-email-auto-complete__users-input__invisible-input"
                            spellcheck="false"
                            @keydown.delete="onInputDelete"
                            @keyup.188="onInputPush"
                            @keydown.enter.prevent="onInputPush"
                            @blur="onInputBlur"
                        >
                    </div>
                    <span
                        v-if="showLimitLabel && emailLimitNum"
                        :class="['pt-email-auto-complete__users-input__count', {
                            'pt-email-auto-complete__users-input__count--over-limit': isSelectedEmailCountOverLimit,
                        }]"
                    >{{ currentSelectedEmailCount }} / {{ emailLimitNum }}</span>
                </div>
            </div>
            <!--下拉列表-->
            <div
                v-show="isSuggestionDisplay"
                ref="autoCompleteBody"
                class="pt-email-auto-complete__suggest"
            >
                <div class="pt-email-auto-complete__suggest-container">
                    <!--添加邮箱-->
                    <div
                        v-if="isShowAddEmail"
                        class="pt-email-auto-complete__suggest-content"
                    >
                        <p
                            class="pt-email-auto-complete__suggest-content-add-email"
                            @click="onSelect({ label: inputing, value: inputing, type: 'email' }, false)"
                        >
                            {{ `${$t('emailAlertBiz.common.emailAutoComplete.addEmail')}${inputing}` }}
                        </p>
                    </div>
                    <!--团队-->
                    <div
                        class="pt-email-auto-complete__suggest-content pt-email-auto-complete__suggest-team"
                    >
                        <div class="pt-email-auto-complete__suggest-content-title">
                            <span>{{ $t('emailAlertBiz.common.emailAutoComplete.team') }}</span>
                            <span
                                v-if="passportUrl"
                                class="pt-email-auto-complete__suggest-content-title__link"
                                @click="linkToTeamManage"
                            >{{ $t('emailAlertBiz.common.emailAutoComplete.teamManage') }}</span>
                        </div>
                        <div
                            v-if="isLoadingList"
                            class="pt-email-auto-complete__suggest-content-loading"
                        >
                            <PtIcon icon="SolidLoadingBars" />
                        </div>
                        <template v-else>
                            <div
                                v-if="filteredGroupList.length"
                                class="pt-email-auto-complete__suggest-content-body"
                            >
                                <div
                                    v-for="(item, index) in filteredGroupList"
                                    :key="index"
                                    class="pt-email-auto-complete__suggest-content-item"
                                    @click="onSelect(item)"
                                >
                                    <!-- eslint-disable max-len -->
                                    <span
                                        :style="{ 'background-color': getSuggestionColor(item.firstLatter) }"
                                        class="pt-email-auto-complete__suggest-content-item-avator pt-email-auto-complete__suggest-content-item-avator--group"
                                    >
                                        {{ item.firstLatter }}
                                    </span>
                                    <!--eslint-enable-->
                                    <div
                                        class="pt-email-auto-complete__suggest-content-item-text"
                                    >
                                        <!-- eslint-disable vue/no-v-html -->
                                        <p
                                            class="pt-email-auto-complete__suggest-content-item-text__label"
                                            :title="item.displayLabel"
                                            v-html="item.displayLabel"
                                        />
                                        <span
                                            v-if="item.external"
                                            class="pt-email-auto-complete__suggest-content-item-text__tip"
                                        >({{ $t('emailAlertBiz.common.emailAutoComplete.includeExternal') }})</span>
                                    </div>
                                    <!-- eslint-enable -->
                                    <p class="pt-email-auto-complete__suggest-content-item-sub">
                                        {{ $t('emailAlertBiz.common.emailAutoComplete.teamCount', { count: item.total }) }}
                                    </p>
                                </div>
                            </div>
                            <div
                                v-else
                                class="pt-email-auto-complete__suggest-content-nodata"
                            >
                                {{ $t('emailAlertBiz.common.emailAutoComplete.noMatchedTeam') }}
                            </div>
                        </template>
                    </div>
                    <!--个人-->
                    <div class="pt-email-auto-complete__suggest-content pt-email-auto-complete__suggest-user">
                        <div class="pt-email-auto-complete__suggest-content-title">
                            {{ $t('emailAlertBiz.common.emailAutoComplete.single') }}
                        </div>
                        <div
                            v-if="isLoadingList"
                            class="pt-email-auto-complete__suggest-content-loading"
                        >
                            <PtIcon icon="SolidLoadingBars" />
                        </div>
                        <template v-else>
                            <div
                                v-if="filteredEmailList.length"
                                class="pt-email-auto-complete__suggest-content-user-body"
                            >
                                <div
                                    v-for="(item, index) in filteredEmailList"
                                    :key="index"
                                    :class="{
                                        'pt-email-auto-complete__suggest-content-item': true,
                                        'pt-email-auto-complete__suggest-content-item--disabled': item.disabled
                                    }"
                                    @click="onSelect(item)"
                                >
                                    <span
                                        :style="{ 'background-color': getSuggestionColor(item.firstLatter) }"
                                        class="pt-email-auto-complete__suggest-content-item-avator"
                                    >
                                        {{ item.firstLatter }}
                                    </span>
                                    <div
                                        class="pt-email-auto-complete__suggest-content-item-text"
                                    >
                                        <p
                                            v-if="item.nickname"
                                            class="nick-name"
                                            v-html="item.nicknameDisplay"
                                        />
                                        <div class="user-info">
                                            <ElPopover
                                                v-if="item.email"
                                                placement="top"
                                                trigger="hover"
                                                :visible-arrow="false"
                                                :open-delay="200"
                                                :close-delay="0"
                                                popper-class="pt-email-auto-complete__popover"
                                            >
                                                <span
                                                    slot="reference"
                                                    class="user-info-email"
                                                    v-html="item.emailDisplay"
                                                />
                                                <p
                                                    style="max-width: 500px;"
                                                    v-html="item.emailDisplay"
                                                />
                                            </ElPopover>
                                            <span
                                                v-if="item.mobile_number"
                                                class="user-info-mobile-number"
                                                v-html="item.mobileNumberDisplay"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-else
                                class="pt-email-auto-complete__suggest-content-nodata"
                            >
                                {{ $t('emailAlertBiz.common.emailAutoComplete.noMatchedSingle') }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable max-len */
import $ from 'jquery';
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';
import _ from 'lodash';
import Popover from 'element-ui/lib/popover';
import { checkEmail, getSuggestionColor, getMoblieDesensitization } from '../../utils/index';

export default {
    name: 'EmailAutoComplete',
    components: {
        PtIcon,
        ElPopover: Popover,
    },
    props: {
        placeholderContent: {
            type: String,
            default: '',
        },
        inputing: {
            type: String,
            default: '',
        },
        selected: {
            type: Array,
            default: () => ([]),
        },
        autocompleteWidth: {
            type: String,
            default: '100%',
        },
        scrollSelector: {
            type: String,
            default: '.pz-email-alert__body.email-alert-dialog',
        },
        passportUrl: {
            type: String,
            default: '',
        },
        getEmailList: {
            type: Function,
            default: () => _.noop(),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        emailLimitNum: {
            type: Number,
            default: 0,
        },
        showLimitLabel: {
            type: Boolean,
            default: false,
        },
        enableSelectWhenOverLimit: {
            type: Boolean,
            default: false,
        },
        /**
         * 只能选择，用户输入的邮箱无效（没有userId）
         */
        onlySelect: {
            type: Boolean,
            default: false,
        },
        /** *
         * 搜索结果不展示的用户userids
         */
        noDisplayList: {
            type: Array,
            default: () => ([]),
        },
        /**
         * 是否只能分享邮箱
         */
        onlyShareEmail: {
            type: Boolean,
            default: true,
        },
        /**
         * 需要标红的错误列表
         */
        errorUserList: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            size: 28,
            fontSize: 16,
            hasTick: false,
            isSuggestionDisplay: false,
            isFocus: false,
            isLoadingList: true,
            emailList: [],
            groupList: [],
            isClickDisabled: false,
            currentSelectedEmailCount: 0,
        };
    },
    computed: {
        isPlaceholderDisplay() {
            return this.currentSelected.length === 0 && this.currentInputing.length === 0;
        },
        currentInputing: {
            get() {
                return this.inputing;
            },
            set(newInputing) {
                this.$emit('update:inputing', newInputing);
            },
        },
        currentSelected: {
            get() {
                return this.selected;
            },
            set(newSelected) {
                this.$emit('update:selected', newSelected);
            },
        },
        isSomeoneEmailInvalid() {
            return _.some(this.currentSelected, (item) => !item.isValid);
        },
        filteredEmailList() {
            const currentSelectedEmailStr = this.currentSelected.filter((item) => item.type === 'email')
                .map((item) => item.value);
            return this.emailList.filter((item) => !(currentSelectedEmailStr.includes(item.value) || this.noDisplayList.includes(item.userId)));
        },
        filteredGroupList() {
            const currentSelectedEmailStr = this.currentSelected.filter((item) => item.type === 'group')
                .map((item) => item.value);
            return this.groupList.filter((item) => !currentSelectedEmailStr.includes(item.value));
        },
        isShowAddEmail() {
            return !this.filteredGroupList.length
                && !this.filteredEmailList.length
                && checkEmail(this.inputing);
        },
        isSelectedEmailCountOverLimit() {
            return this.currentSelectedEmailCount > this.emailLimitNum;
        },
    },
    watch: {
        currentSelected: {
            handler() {
                this.currentSelectedEmailCount = this.getCurrentSelectedEmailCount();
                this.$emit('updateCurrentSelectedEmailCount', this.currentSelectedEmailCount);
                // eslint-disable-next-line func-names
                this.$nextTick(function () {
                    this.onInputChange();
                });
            },
            immediate: true,
        },
        currentInputing() {
            this.getAddressList();
        },
        loading(val) {
            if (!val) {
                // eslint-disable-next-line func-names
                this.$nextTick(function () {
                    this.onInputChange();
                });
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.closeAutoComplete);
        this.getAddressList();
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeAutoComplete);
    },
    methods: {
        getSuggestionColor,
        onFocus() {
            this.$refs.input.focus();
            this.isSuggestionDisplay = true;
            this.isFocus = true;
            this.$nextTick(() => {
                // scrollSelector元素滚动到屏幕滚动到scrollSelector的底部
                if (!$(this.scrollSelector)[0]) return;
                $(this.scrollSelector).scrollTop($(this.scrollSelector)[0].scrollHeight);
            });
        },
        onSelect(item, checkExist = true) {
            this.isClickDisabled = false;
            // 点击禁止选中的选项时，不选中该数据
            if (item.disabled) {
                this.isClickDisabled = true;
                return;
            }
            if (this.emailLimitNum && this.currentSelectedEmailCount >= this.emailLimitNum) {
                this.$emit('onEmailUpperLimit');
                if (!this.enableSelectWhenOverLimit) return;
            }
            const found = checkExist ? _.find(this.currentSelected, { value: item.value }) : null;
            if (!found) {
                this.currentSelected.push({
                    label: item.label,
                    value: item.value,
                    type: item.type,
                    total: item.total,
                    isValid: true,
                    userId: item.userId,
                    mobileNumber: item.mobileNumber,
                    nickname: item.nickname,
                    email: item.email,
                });
                this.currentInputing = '';
                this.$emit('selectUser', item);
            }
            this.$nextTick(() => {
                const usersInputEl = $('.pt-email-auto-complete__users-input');
                usersInputEl.scrollTop(usersInputEl[0].scrollHeight);
            });
        },
        onInputChange() {
            const suggestion = this.$refs.autoCompleteBody;
            const { container } = this.$refs;
            const height = container.offsetHeight;
            const top = height + 4;
            suggestion.style.top = `${top}px`;
        },
        onRemoveSelected(user) {
            const index = this.currentSelected.indexOf(user);
            this.currentSelected.splice(index, 1);
            this.$emit('removeUser', user);
        },
        onInputDelete() {
            if (this.currentInputing === '') {
                const deleteUser = this.currentSelected.pop();
                this.$emit('removeUser', deleteUser);
            }
        },
        onInputPush(event) {
            if (this.onlySelect) {
                return;
            }
            // 中文输入法下，enter keyCode 229
            // 此时不需执行该函数
            if (event && event.keyCode === 229) return;
            if (this.emailLimitNum && this.currentSelected.length >= this.emailLimitNum) {
                this.currentInputing = '';
                this.$emit('onEmailUpperLimit');
                if (!this.enableSelectWhenOverLimit) return;
            }
            let user = {};
            let userEmail = '';
            if (event && event.keyCode === 188) {
                userEmail = this.currentInputing.slice(0, this.currentInputing.length - 1);
            } else {
                userEmail = this.currentInputing;
            }
            userEmail = userEmail.trim();
            user = {
                userId: userEmail,
                label: userEmail,
                value: userEmail,
                type: 'email',
                isValid: checkEmail(userEmail),
            };
            if (!_.isEmpty(userEmail)) {
                this.currentSelected.push(user);
                this.currentInputing = '';
                this.$refs.input.focus();
            }
            this.$emit('inputPush', user);
            this.$nextTick(() => {
                const usersInputEl = $('.pt-email-auto-complete__users-input');
                usersInputEl.scrollTop(usersInputEl[0].scrollHeight);
            });
        },
        closeAutoComplete(e) {
            const vm = this;
            const { target } = e;
            const els = vm.$refs;
            const { wrapper } = els;
            const $wrapper = $(wrapper);
            if (
                // !$el.is(target) &&
                // $el.has(target).length === 0 &&
                (!$wrapper.is(target) && $wrapper.has(target).length === 0)
                && !vm.isClickDisabled
            ) {
                vm.isSuggestionDisplay = false;
                vm.isFocus = false;
            }
        },
        onInputBlur() {
            // 输入框失去焦点有可能是点了下面suggestion的选项
            setTimeout(() => {
                if (this.isClickDisabled) {
                    // 禁止选中的选项不失焦
                    this.onFocus();
                    this.isClickDisabled = false;
                    return;
                }
                if (this.currentInputing.length) {
                    this.onInputPush();
                }
            }, 500);
        },
        // eslint-disable-next-line func-names
        getAddressList: _.debounce(async function () {
            this.isLoadingList = true;
            try {
                const res = await this.getEmailList(this.currentInputing || '');
                const inputReg = new RegExp(this.currentInputing, 'i');
                this.emailList = _.get(res, 'email', []).map((user) => {
                    const displayLabel = user.nickname || user.email || getMoblieDesensitization(user.mobile_number);
                    return {
                        ...user,
                        type: 'email',
                        value: user.email || user.mobileNumber,
                        label: user.email || user.mobileNumber,
                        firstLatter: displayLabel.slice(0, 1).toUpperCase(),
                        displayLabel: this.currentInputing
                            ? displayLabel.replace(inputReg, `<b>${this.currentInputing}</b>`)
                            : displayLabel,
                        nicknameDisplay: this.currentInputing && user.nickname
                            ? _.escape(user.nickname).replace(inputReg, `<b>${this.currentInputing}</b>`)
                            : _.escape(user.nickname),
                        emailDisplay: this.currentInputing && user.email
                            ? user.email.replace(inputReg, `<b>${this.currentInputing}</b>`)
                            : user.email,
                        mobileNumberDisplay: this.currentInputing && user.mobile_number
                            ? getMoblieDesensitization(user.mobile_number).replace(inputReg, `<b>${this.currentInputing}</b>`)
                            : getMoblieDesensitization(user.mobile_number),
                        disabled: this.onlyShareEmail ? !user.email : false,
                    };
                });
                this.groupList = _.get(res, 'group', []).map((group) => ({
                    type: 'group',
                    value: group.group_id,
                    label: group.name,
                    total: group.total,
                    firstLatter: group.name.slice(0, 1).toUpperCase(),
                    displayLabel: this.currentInputing
                        ? group.name.replace(inputReg, `<b>${this.currentInputing}</b>`)
                        : group.name,
                    external: _.get(group, 'contain_external_member', false),
                }));
            } catch (err) {
                this.emailList = [];
                this.groupList = [];
            }
            this.isLoadingList = false;
        }, 500),
        linkToTeamManage() {
            const url = `${this.passportUrl}/user/team_group`;
            window.open(url);
        },
        getCurrentSelectedEmailCount() {
            /* email总数量 = email count + group total  */
            // email count
            // const userEmailCount = (this.currentSelected.filter(({ type }) => type === 'email') || []).length;
            // group total
            // const groupEmailCount = (this.currentSelected.filter(({ type }) => type === 'group') || []).reduce((total, group) => total + group.total || 0, 0);
            // return userEmailCount + groupEmailCount || 0;

            /* 2022.8.12 需求变更为同group只算一个用户,上述代码先暂不删除 */
            /* email总数量 = currentSelected.length  */
            return this.currentSelected.length;
        },
    },
};
</script>
